var render, staticRenderFns
import script from "./Linkout.vue?vue&type=script&lang=js&"
export * from "./Linkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734302f8')) {
      api.createRecord('734302f8', component.options)
    } else {
      api.reload('734302f8', component.options)
    }
    
  }
}
component.options.__file = "src/js/components/Linkout.vue"
export default component.exports